import { useTranslation } from 'next-i18next/pages';

import Area from '@/components/apps/layouts/shared/Area';
import InquiryFormContainer from '@/components/apps/ui/inquiryForm/InquiryFormContainer';
import type { InquirySubmitAction } from '@/components/apps/ui/inquiryForm/inquirySubmission';

import Subtop from '../../ui/subtop/Subtop';

type Props = {
  submitAction?: InquirySubmitAction;
};

export default function InquiryBoardCreate({ submitAction }: Props) {
  const { t } = useTranslation('common');

  return (
    // ::before 의 image-set() 배경 + 미디어쿼리 이미지 교체라 globals.css 의 .subtop-wave-bg 를 재사용한다.
    // (isolation: isolate 가 ::before(z-index:-1) 가 루트까지 빠져나가 Main 배경 뒤로 숨는 것을 막는다)
    <div className="subtop-wave-bg">
      <Subtop title={t('문의하기')} />

      <Area>
        {/* 게시글 작성 폼 */}
        <InquiryFormContainer submitAction={submitAction} />
      </Area>
    </div>
  );
}
